import { z } from 'zod';

export const strongPasswordZodSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters long')
  .max(64, 'Password cannot exceed 64 characters')
  .refine((value) => /[A-Z]/.test(value), 'Password must contain at least one uppercase letter')
  .refine((value) => /[a-z]/.test(value), 'Password must contain at least one lowercase letter')
  .refine((value) => /[0-9]/.test(value), 'Password must contain at least one digit')
  .refine(
    (value) => /[!@#$%^&*()\-_=+[\]{}|;:'",.<>/?\\]/.test(value),
    'Password must contain at least one special character'
  );
